import styled from 'styled-components';

export const $Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  background: linear-gradient(90deg, #005e3f, #003926);
  border-radius: 100px;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const $Label = styled.span`
  color: #2ed59d;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const $Message = styled.span`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.3px;
  flex: 1;
`;

export const $CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  padding: 4px;
  margin-left: 8px;
  margin-right: -8px;

  &:hover {
    opacity: 0.8;
  }
`;
